import { Spin } from "antd";
import React, { Suspense } from "react";
import { Route, Redirect } from "react-router-dom";
import AppLayout from "../components/layout/AppLayout";
import useAuth from "../hooks/useAuth";

interface IProps {
	exact?: boolean;
	path: string;
	permission?: boolean;
	children: React.ReactNode;
}

const PrivateRoute: React.FC<IProps> = ({ children, permission, ...rest }) => {
	const { isLoggedIn } = useAuth();

	const permissionRole = typeof permission === "undefined" ? true : permission;
	return (
		<Route
			{...rest}
			render={({ location, match }: any) => {
				if (!isLoggedIn) {
					return (
						<Redirect
							to={{
								pathname: "/",
								state: { from: location },
							}}
						/>
					);
				} else if (!permissionRole) {
					return (
						<Redirect
							to={{
								pathname: "/forbidden",
								state: { from: location },
							}}
						/>
					);
				} else {
					return (
						<AppLayout>
							<Suspense
								fallback={
									<Spin size="large">
										<div style={{ width: "100%", height: "100%" }}></div>
									</Spin>
								}
							>
								{children}
							</Suspense>
						</AppLayout>
					);
				}
			}}
		/>
	);
};

export default PrivateRoute;
